import {
    differenceInMinutes,
    differenceInHours,
    differenceInDays,
} from "date-fns";
import { messages } from "src/translations/translations";
import * as Yup from 'yup';
import { conditionalUsername, first_name, last_name, username } from "./definitionsYup";
import jwtDecode from "jwt-decode";

export const isValidToken = (accessToken: string) => {
    const decodedToken = jwtDecode(accessToken) as { exp: number };
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
};

export function loginValidationSchema() {
    return Yup.object().shape({
        username,
        password: Yup.string()
          .required('yupPasswordRequired'),
      });
};

export function createConditionalPwordSchema(regex: RegExp) {
    return Yup.object().shape({
        password: Yup.string()
        .when('via_email', {
          is: false,
          then: () => Yup.string()
          .matches(
            regex,
            'yupPasswordInvalidCharacters'
          )
          .min(9, 'yupPasswordMin')
          .max(20, 'yupPasswordMax')
          .required('yupPasswordRequired'),
        }),
        username: conditionalUsername,
        first_name,
        last_name,
    });
};

export function formatTimeAgo(userLanguage: string, inputDate: Date | null) {

    if (!inputDate) {
        return messages[userLanguage].never
    }
    const currentDate = new Date();
    const inputDateObj = new Date(inputDate);

    const diffMinutes = differenceInMinutes(currentDate, inputDateObj);
    const diffHours = differenceInHours(currentDate, inputDateObj);
    const diffDays = differenceInDays(currentDate, inputDateObj);

    const remainingMinutes = diffMinutes % 60;

    if (diffDays >= 1) {
        if (diffDays < 2) {
            return '1' + messages[userLanguage].dayAgo;
        }
        return diffDays + messages[userLanguage].daysAgo;
    }
    else {
        if (diffHours >= 1) {
            if (diffHours < 2) {
                if (diffMinutes > 1) {
                    return (
                        diffHours +
                        messages[userLanguage].hourAnd +
                        remainingMinutes +
                        messages[userLanguage].minutesAgo
                    );
                }
                return (
                    diffHours +
                    messages[userLanguage].hourAnd +
                    remainingMinutes +
                    messages[userLanguage].minuteAgo
                );
            }
            if (diffMinutes > 1) {
                return (
                    diffHours +
                    messages[userLanguage].hoursAnd +
                    remainingMinutes +
                    messages[userLanguage].minutesAgo
                );
            }
            return (
                diffHours +
                messages[userLanguage].hoursAnd +
                remainingMinutes +
                messages[userLanguage].minuteAgo
            );
        }
        else {
            if (diffMinutes > 1) {
                return (
                    diffMinutes +
                    messages[userLanguage].minutesAgo
                );
            }
            return messages[userLanguage].lessThanMinuteAgo;
        }
    }
}